const environment = {
    priceMin: 1000000,
    priceMax: 6000000,
    priceDefault: 3300000,
    priceStep: 100000,
    feeMin: 10,
    feeMax: 60,
    feeDefault: 13,
    termMin: 1,
    termMax: 60,
    termDefault: 60,
    interestRate: 3.5,
};

export default environment;